/**
 * WordPress dependencies
 */
import { getElement, store, getContext } from '@wordpress/interactivity';

store( 'link-group', {
	callbacks: {
		
	},
} );
